(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sold-artworks"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sold-artworks')) {
    customElements.define('sold-artworks', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.grid = this.querySelector('ul');
        this.status = this.querySelector('[role="status"]');
        this.retry = this.querySelector('.sold-artworks__retry');
        this.pagination = this.querySelector('nav');
        this.paginationWrapper = this.querySelector('.sold-artworks__pagination-wrapper');
        this.pool = [];
        this.sourceCursor = null;
        this.fullyLoaded = false;
        this.page = 1;
        this.grid.replaceChildren();
        this.retry.onclick = () => this.load();
        this.onHistoryChange = () => { if (this.fullyLoaded) this.renderPage(this.requestedPage()); };
        window.addEventListener('popstate', this.onHistoryChange);
        this.load();
      }
      disconnectedCallback() { this.controller?.abort(); window.removeEventListener('popstate', this.onHistoryChange); this.initialized = false; }
      async load() {
        if (this.busy || (!this.dataset.vendor && !this.dataset.collectionId)) return;
        this.busy = true;
        this.retry.disabled = true;
        this.retry.hidden = true;
        this.setAttribute('aria-busy', 'true');
        this.status.textContent = this.dataset.loadingLabel;
        this.controller = new AbortController();
        try {
          const url = new URL(this.dataset.endpoint, location.origin);
          if (url.origin !== location.origin || !url.pathname.startsWith('/apps/')) throw new Error('Invalid gallery path');
          if (this.dataset.collectionId) url.searchParams.set('collection_id', this.dataset.collectionId);
          else url.searchParams.set('vendor', this.dataset.vendor);
          if (this.dataset.artistTag) url.searchParams.set('artist_tag', this.dataset.artistTag);
          while (!this.fullyLoaded) {
            if (this.sourceCursor) url.searchParams.set('after', this.sourceCursor);
            else url.searchParams.delete('after');
            url.searchParams.set('gallery_request', String(Date.now()));
            const data = await this.fetchPage(url);
            if (!Array.isArray(data.artworks) || (data.nextCursor && data.nextCursor === this.sourceCursor)) throw new Error('Invalid gallery page');
            this.pool.push(...data.artworks);
            this.sourceCursor = data.nextCursor;
            this.fullyLoaded = !this.sourceCursor;
          }
          this.pool.sort((a, b) => (b.saleDate || '').localeCompare(a.saleDate || '') || a.title.localeCompare(b.title));
          this.retry.hidden = true;
          this.renderPage(this.requestedPage());
        } catch {
          if (!this.isConnected) return;
          this.status.textContent = this.dataset.errorLabel;
          this.retry.hidden = false;
        } finally {
          this.busy = false;
          this.retry.disabled = false;
          this.removeAttribute('aria-busy');
        }
      }
      async fetchPage(url) {
        for (let attempt = 0; attempt < 3; attempt++) {
          const controller = new AbortController();
          const cancel = () => controller.abort();
          this.controller.signal.addEventListener('abort', cancel, { once: true });
          const timeout = setTimeout(cancel, 15000);
          try {
            if (this.controller.signal.aborted) throw new Error('Cancelled');
            const response = await fetch(url, { signal: controller.signal, cache: 'no-store' });
            if (!response.ok) {
              const error = new Error('Gallery unavailable');
              error.retryable = response.status === 408 || response.status === 429 || response.status >= 500;
              throw error;
            }
            return await response.json();
          } catch (error) {
            if (this.controller.signal.aborted || error.retryable === false || attempt === 2) throw error;
          } finally {
            clearTimeout(timeout);
            this.controller.signal.removeEventListener('abort', cancel);
          }
          await new Promise((resolve, reject) => {
            const signal = this.controller.signal;
            const cancel = () => { clearTimeout(timer); reject(new Error('Cancelled')); };
            const timer = setTimeout(() => { signal.removeEventListener('abort', cancel); resolve(); }, 750 * (attempt + 1));
            if (signal.aborted) cancel();
            else signal.addEventListener('abort', cancel, { once: true });
          });
          url.searchParams.set('gallery_request', String(Date.now()));
        }
      }
      requestedPage() {
        const page = new URL(location.href).searchParams.get('sold_page');
        return /^[1-9][0-9]*$/.test(page || '') ? Number(page) : 1;
      }
      renderPage(page, navigate = false) {
        const totalPages = Math.max(1, Math.ceil(this.pool.length / 15));
        this.page = Math.max(1, Math.min(Number.isFinite(page) ? page : 1, totalPages));
        const batch = this.pool.slice((this.page - 1) * 15, this.page * 15);
        this.grid.replaceChildren();
          for (const artwork of batch) {
            const item = document.createElement('li');
            item.dataset.saleDate = artwork.saleDate || '';
            const figure = document.createElement('figure');
            if (artwork.image) {
              const image = document.createElement('img');
              image.src = artwork.image.url;
              image.alt = artwork.image.alt || artwork.title;
              image.loading = 'lazy';
              image.decoding = 'async';
              if (artwork.image.width) image.width = artwork.image.width;
              if (artwork.image.height) image.height = artwork.image.height;
              figure.append(image);
            } else {
              const placeholder = document.createElement('div');
              placeholder.className = 'sold-artworks__placeholder';
              placeholder.textContent = this.dataset.noImage;
              figure.append(placeholder);
            }
            const caption = document.createElement('figcaption');
            const title = document.createElement('span');
            title.className = 'sold-artworks__title';
            title.textContent = artwork.title;
            const badge = document.createElement('span');
            badge.className = 'sold-artworks__badge';
            badge.textContent = this.dataset.soldLabel;
            caption.append(title, badge);
            figure.append(caption);
            item.append(figure);
            this.grid.append(item);
          }
        this.pagination.replaceChildren();
        this.paginationWrapper.hidden = totalPages <= 1;
        this.paginationWrapper.dataset.page = String(this.page);
        const controls = document.createElement('ul');
        controls.className = 'pagination__list list-unstyled';
        controls.setAttribute('role', 'list');
        this.pagination.append(controls);
        const addButton = (label, target, disabled = false, current = false) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'pagination__item link';
          if (label === 'Previous' || label === 'Next') {
            button.classList.add('pagination__item-arrow', label === 'Next' ? 'pagination__item--prev' : 'pagination__item--next');
            button.innerHTML = '<span class="svg-wrapper"><svg class="icon icon-caret" viewBox="0 0 10 6" aria-hidden="true"><path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"></path></svg></span>';
          } else button.textContent = label;
          button.disabled = disabled;
          if (current) { button.setAttribute('aria-current', 'page'); button.classList.add('pagination__item--current', 'light'); }
          button.setAttribute('aria-label', label === 'Previous' || label === 'Next' ? label + ' sold artwork page' : 'Sold artwork page ' + label);
          button.onclick = () => this.renderPage(target, true);
          const item = document.createElement('li');
          item.append(button);
          controls.append(item);
        };
        addButton('Previous', this.page - 1, this.page === 1);
        const pages = new Set([1, totalPages]);
        for (let i = Math.max(1, this.page - 2); i <= Math.min(totalPages, this.page + 2); i++) pages.add(i);
        let previous = 0;
        for (const number of [...pages].sort((a, b) => a - b)) {
          if (previous && number - previous > 1) {
            const dots = document.createElement('span');
            dots.textContent = '…';
            dots.setAttribute('aria-hidden', 'true');
            dots.className = 'pagination__item';
            const gap = document.createElement('li');
            gap.append(dots);
            controls.append(gap);
          }
          addButton(String(number), number, false, number === this.page);
          previous = number;
        }
        addButton('Next', this.page + 1, this.page === totalPages);
        this.status.textContent = this.pool.length ? 'Page ' + this.page + ' of ' + totalPages : this.dataset.emptyLabel;
        if (navigate) {
          const url = new URL(location.href);
          if (this.page === 1) url.searchParams.delete('sold_page');
          else url.searchParams.set('sold_page', String(this.page));
          history.pushState(null, '', url);
          this.scrollIntoView({ block: 'start', behavior: 'auto' });
          this.querySelector('h2').focus({ preventScroll: true });
        }
      }

    });
  }

  } catch(e) { console.error(e); }
})();
})();
